import { AloftPrice, AloftPriceJSON } from '@aloft/toolkit-shared';

// This is exported so that CompCard can use it directly
// with form values that are not yet in Redux.
export const calculateMarketAdjustedSalePrice = ({
  price,
  marketAdjustment,
}: {
  price: AloftPriceJSON | undefined;
  marketAdjustment: AloftPrice;
}): AloftPrice => {
  if (!price) return AloftPrice.zero;

  return AloftPrice.schema.parse(price).add(marketAdjustment);
};
